import TomSelect from "tom-select";

export async function setupTomSelect(
    source: object[] | string,
    selectName: string,
    placeholder: string,
    parent: string,
    dataTextField: string,
    objectIdField: string = "id",
    isMultiple: boolean = false,
    allowClear: boolean = false
) {
    let data: any[] = [];
    if (typeof source === 'string') {
        const response = await fetch(source);
        data = await response.json();
    } else {
        data = [...source];
    }

    const results = data.map((item: any) => {
        const selectItem: any = { ...item };
        if (objectIdField !== "id") selectItem.id = item[objectIdField];
        selectItem.text = item[dataTextField];
        return selectItem;
    });
    results.sort((a: { text: string }, b: { text: string }) => a.text.localeCompare(b.text));

    const selector = `${parent} ${selectName}`;
    const element = document.querySelector(selector);

    if (element) {
        if ((element as any).tomselect) {
            (element as any).tomselect.destroy();
        }
        new TomSelect(element as HTMLSelectElement, {
            options: results,
            valueField: 'id',
            labelField: 'text',
            searchField: ['text'],
            placeholder: placeholder,
            maxItems: isMultiple ? null : 1,
            allowEmptyOption: allowClear,
            plugins: (isMultiple ? ['remove_button'] : []) as any,
            create: false,
            onInitialize: function() {
                // @ts-ignore
                this.control_input.setAttribute('autocomplete', 'off');
                // @ts-ignore
                this.control_input.setAttribute('data-lpignore', 'true');
            }
        });
    } else {
        console.error(`Element not found: ${selector}`);
    }
}
